import { ligainicial } from "./rutainicial.js";

const ligabase = ligainicial + "2019/Inv/";

export const invitaciones2019 = [
    {
        'numInvitacion' : 'IO-913005997-E6-2019',
        'procedimiento' : [
            {
                'numProc' : 'Procedimiento de Invitación a Cuando Menos Tres Personas núm. IO-913005997-E6-2019',
                'vigenciaProc' : 'Vigencia: 9 de noviembre de 2018 (único día)',
                'descripcionProc' : 'Construcción de 2,359.56 m2 de pavimentación asfáltica del kilómetro 1+176.08 al 1+569.34 del camino de la localidad de Benito Juárez (Detzani) a la localidad de El Barrón, Municipio de Zimapán, Hidalgo. Etapa 2; ubicada en la localidad de Barrón, Municipio de Zimapán, Estado de Hidalgo.',
                'urlAnexosProc' : `${ ligabase }E6/E6.rar`,
                'resultadosProc' : [
                    {
                        'resultado' : 'Junta de Aclaraciones',
                        'urlResultado' : `${ ligabase }E6/JAE6.pdf`,
                    },
                ]
            }
        ]
    },
    {
        'numInvitacion' : 'IO-913005997-E5-2019',
        'procedimiento' : [
            {
                'numProc' : 'Procedimiento de Invitación a Cuando Menos Tres Personas núm. IO-913005997-E5-2019',
                'vigenciaProc' : 'Vigencia: 13 de mayo de 2019 (único día)',
                'descripcionProc' : 'Construcción de 2,194.50 m2 de pavimento hidráulico en acceso al Colegio de Bachilleres del Estado de Hidalgo, en la localidad de Acoxcatlán, Municipio de Tepehuacán de Guerrero, Hidalgo; ubicada en la localidad de Acoxcatlán, Municipio de Tepehuacán de Guerrero, Estado de Hidalgo.',
                'urlAnexosProc' : `${ ligabase }E5/E5.rar`,
                'resultadosProc' : [
                    {
                        'resultado' : 'Junta de Aclaraciones',
                        'urlResultado' : `${ ligabase }E5/JAE5.pdf`,
                    },
                ]
            }
        ]
    },
    {
        'numInvitacion' : 'IO-913005997-E4-2019',
        'procedimiento' : [
            {
                'numProc' : 'Procedimiento de Invitación a Cuando Menos Tres Personas núm. IO-913005997-E4-2019',
                'vigenciaProc' : 'Vigencia: 13 de mayo de 2019 (único día)',
                'descripcionProc' : 'Construcción de 460.57 m2 de pavimento hidráulico y 133.50 m2 de canal de aguas pluviales en calle sin nombre de la localidad Tolago, Municipio de Lolotla, Hidalgo; ubicada en la localidad de Tolago, Municipio de Lolotla, Estado de Hidalgo.',
                'urlAnexosProc' : `${ ligabase }E4/E4.rar`,
                'resultadosProc' : [
                    {
                        'resultado' : 'Junta de Aclaraciones',
                        'urlResultado' : `${ ligabase }E4/JAE4.pdf`,
                    },
                ]
            }
        ]
    },
]